module.exports = __webpack_public_path__ + "static/media/icon_hearth.44653e1a.svg";